import { r, s } from '@/theme/tokens';
import type { SpacingToken } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const tagChipGap: SpacingToken = 'sm';

export const tagChipGroupSx = {
  columnGap: s(tagChipGap),
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: `calc(22px * 2 + ${s('sm')})`,
  minWidth: 0,
  overflow: 'hidden',
  rowGap: s('sm'),
  width: '100%',
} as const satisfies SxProps<Theme>;

export const denseTagChipGroupSx = {
  ...tagChipGroupSx,
  display: 'grid',
} as const satisfies SxProps<Theme>;

export const buildDenseTagChipColumns = (tagCount: number): string =>
  `repeat(${String(Math.ceil(tagCount / 2))}, minmax(0, 1fr))`;

export const tagChipSx = {
  borderRadius: r('sm'),
  height: '22px',
  maxWidth: '92px',
  minWidth: 0,
  '& .MuiChip-label': {
    minWidth: 0,
    overflow: 'hidden',
    px: s('md'),
    py: s('xxs'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .MuiChip-label .MuiTypography-root': {
    fontSize: '13px !important',
    lineHeight: 1.2,
  },
} as const satisfies SxProps<Theme>;

export const tableTagChipSx = {
  ...tagChipSx,
  flex: '0 1 auto',
  transition: (theme) =>
    theme.transitions.create(['border-color'], {
      duration: theme.transitions.duration.shortest,
    }),
} satisfies SxProps<Theme>;

export const denseTagChipSx = {
  maxWidth: '82px',
  width: '100%',
} as const satisfies SxProps<Theme>;
